import { Controller } from "@hotwired/stimulus"

// FAQ accordion: 各 question button click で next sibling の answer を toggle、
// 同時に Q button 内の +/- icon と `aria-expanded` を切り替える。
//
// 各 Q/A pair は ERB が `<button class="faq-question">` の direct sibling として
// `<div class="faq-answer">` を出力する構造に依存する。controller は targets で
// 各要素を集める形ではなく、`event.currentTarget` からの相対 DOM 探索で完結させる
// (各 Q/A pair の対応関係を index ではなく DOM sibling 関係で表現するため)。
//
// Stimulus 化で自動化:
// - 旧 inline JS の `cloneNode(true)` で listener を貼り直す 多重 bind 防止策は不要
//   (Stimulus が controller scope 内で data-action 経由の event 配線を 1 回だけ行う)
// - 旧 inline JS の `turbo:load` / `turbo:frame-load` / `DOMContentLoaded` 多重 listen
//   は connect/disconnect の lifecycle 管理で代替
export default class extends Controller {
  toggle(event) {
    const question = event.currentTarget
    const answer = question.nextElementSibling
    const plusIcon = question.querySelector(".faq-icon-plus")
    const minusIcon = question.querySelector(".faq-icon-minus")

    const isOpening = answer.classList.contains("hidden")
    answer.classList.toggle("hidden")
    plusIcon.classList.toggle("hidden")
    minusIcon.classList.toggle("hidden")
    question.setAttribute("aria-expanded", isOpening ? "true" : "false")
  }
}
